var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrice = function SvgPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.401 22.594H6.406V8.529l3.13-3.328H11.7v1.408h-1.408v1.407h4.222V6.609h-1.408V5.201h2.165l3.13 3.328v14.065zm-2.52-18.8 3.927 4.178V24H5V7.972l3.928-4.177H11.7V0h1.406v3.795h2.773zm-3.826 8.444h.698c.652 0 1.182.53 1.182 1.182h1.406c0-1.307-.974-2.39-2.234-2.564V9.424h-1.406v1.432a2.592 2.592 0 0 0-2.234 2.564 2.591 2.591 0 0 0 2.588 2.588h.698a1.183 1.183 0 0 1 0 2.364h-.698c-.652 0-1.182-.53-1.182-1.182H9.467c0 1.307.974 2.39 2.234 2.563v1.433h1.406v-1.433a2.592 2.592 0 0 0 2.234-2.563 2.591 2.591 0 0 0-2.588-2.588h-.698a1.183 1.183 0 0 1 0-2.364z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};
export default SvgPrice;